import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../containers/host/home";
import HostLayout from "../components/layouts/host-layout";
import HostProfile from "../containers/host/host-profile";
import EditProfile from "../containers/host/edit-profile";
import Subscription from "../containers/host/subscription";
import ResourceLibrary from "../containers/host/resource-library";
import MyBadges from "../containers/host/my-badges";
import MyRepresentatives from "../containers/host/my-representatives";
import MyRating from "../containers/host/my-rating/indes";
import Experiences from "../containers/host/experiences";
import GeneralSettings from "../containers/host/general-setting";
import ExperienceDetail from "../containers/host/experience-detail";
import Attendess from "../containers/host/experience-detail/attendees";
import ReviewsAndCup from "../containers/host/my-rating/reviews-and-cups";
import ManagePayments from "../containers/host/manage-payments";
import Communities from "../containers/host/communities";
import CreateEvent from "containers/host/create-event";
import EventBadges from "containers/host/event-badges";
import MyCancelledTickets from "containers/host/my-cancelled-tickets";
import HostSubscriptionMobile from "containers/host/host-mobile-subscription";




const HostRoutes = () => {
  return (
    <HostLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/experience-detail" element={<ExperienceDetail />} />
        <Route path="/attendess" element={<Attendess />} />
        <Route path="/create-experience" element={<CreateEvent />} />
        <Route path="/communities" element={<Communities />} />
        <Route path="/host-profile" element={<HostProfile />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/resource-library" element={<ResourceLibrary />} />
        <Route path="/my-badges" element={<MyBadges />} />
        <Route path="/my-representatives" element={<MyRepresentatives />} />
        <Route path="/my-ratings" element={<MyRating />} />
        <Route path="/reviews-cups" element={<ReviewsAndCup />} />
        <Route path="/general-setting" element={<GeneralSettings />} />
        <Route path="/manage-payment" element={<ManagePayments />} />
        <Route path="/host-event-badges" element={<EventBadges />} />
        <Route path="/my-cancelled-tickets" element={<MyCancelledTickets />} />
        <Route path="/host-mobile-subscription" element={<HostSubscriptionMobile/>}/>

        
      </Routes>
    </HostLayout>
  );
};

export default HostRoutes;
